import { createCssVariableString, DATE_FORMAT_STR, formatDate, FormatterType, MatchUp } from "best-common-react";
import { Link } from "react-router";
import React from "react";
import styled from "styled-components";
import CompleteConstants from "../../../../constants/CompleteConstants";
import { formatGameDateShort } from "../../../../util/TimeUtil";
import { TotalData } from "./BySeriesTypes";

const GameDateHolder = styled.div.attrs(() => ({
  className: "bcr-me-2",
}))`
  width: 11.5rem;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

type TicketValueProps = {
  subrow: boolean;
};

const TicketValue = styled.span<TicketValueProps>`
  font-weight: ${(props) => (props.subrow ? "inherit" : "bold")};
`;

const Grey = styled.span`
  color: ${createCssVariableString("onColorsOnSurfaceLow")};
`;

const ExclamationIcon = styled.div.attrs({ className: "fas fa-exclamation-circle" })`
  height: 1rem;
  width: 1rem;
  color: #ff9300;
`;

const EventChangeText = styled.span`
  font-size: 0.875rem;
`;

const zero = <Grey>0</Grey>;

export const GameDateFormatter = ({ row, subrow = false }: FormatterType<TotalData>) => {
  const { homeTeam, awayTeam, venue, gameDate, toLink, location, seriesDescription } = row!;
  return (
    <div className="d-flex align-items-center min-w-0">
      <Link
        to={{
          pathname: toLink,
        }}
        state={{ previousLocation: location }}
        className="d-inline-flex align-items-center text-decoration-none"
        style={{ color: "inherit" }}
      >
        {subrow ? <GameDateHolder>{formatGameDateShort(gameDate, venue.timeZone, false)}</GameDateHolder> : null}
        <MatchUp away={awayTeam} home={homeTeam} description={seriesDescription} />
      </Link>
    </div>
  );
};

export const CompleteInCompleteFormatter = ({
  value: { complete, incomplete, filter },
  row,
  subrow = false,
}: FormatterType<TotalData>) => {
  const { toLink, location } = row!;
  return (
    <div>
      <TicketValue subrow={subrow}>
        {incomplete === 0 ? (
          zero
        ) : (
          <Link
            to={{
              pathname: toLink,
              search: `?${filter}&completeId=${CompleteConstants.INCOMPLETE_ID}`,
            }}
            state={{ previousLocation: location }}
          >
            {incomplete}
          </Link>
        )}
        <Grey> | </Grey>
        {complete === 0 ? (
          zero
        ) : (
          <Link
            to={{
              pathname: toLink,
              search: `?${filter}&completeId=${CompleteConstants.COMPLETE_ID}`,
            }}
            state={{ previousLocation: location }}
          >
            {complete}
          </Link>
        )}
      </TicketValue>
    </div>
  );
};

export const LinkFormatter = ({ value: { value, filter }, row, subrow = false }: FormatterType<TotalData>) => {
  const { toLink, location } = row!;
  return (
    <div>
      {value === 0 ? (
        zero
      ) : (
        <Link
          to={{
            pathname: toLink,
            search: filter,
          }}
          state={{ previousLocation: location }}
        >
          <TicketValue subrow={subrow}>{value}</TicketValue>
        </Link>
      )}
    </div>
  );
};

export const EventChangeFormatter = ({ row, subrow = false }: FormatterType<TotalData>) => {
  const { status, rescheduledFrom } = row!;
  let message = "";
  if (status && status.codedGameState === "C") {
    message = "Cancelled";
  } else if (rescheduledFrom) {
    const date = formatDate(rescheduledFrom, DATE_FORMAT_STR);
    message = `Original date - ${date}`;
  } else if (status && status.codedGameState === "D") {
    message = "Postponed";
  }
  if (!subrow && message.length > 0) {
    return <ExclamationIcon />;
  } else {
    return <EventChangeText>{message}</EventChangeText>;
  }
};
